import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";

import ModuleRenderer from "../../ModuleRenderer";
import type { INavColumn } from "../../types";

interface Props {
  column: INavColumn;
}

export const NavColumn = ({ column }: Props) => {
  return (
    <Container
      display="grid"
      alignItems="flex-start"
      gap="sml"
      style={{
        gridTemplateColumns: `repeat(${column.span}, 1fr)`,
        gridColumn: `span ${column.span}`,
      }}
    >
      <ModuleRenderer modules={column.modules} span={column.span} />
    </Container>
  );
};
